import { css, html, LitElement } from 'lit';
import '@kisters/wcp-base/components/ki-icon/ki-icon';
import { customElement } from 'lit/decorators.js';
import { getCurrentApi } from '@kisters/wiski-web/api';
import { getRouteOptionsAndParams } from '@kisters/wcp-base/components';

@customElement('wwp-station-download-epmp')
export class dl extends LitElement {
  static styles = css`
    .row {
      display: table-row;
      line-height: 2em;
    }
    .cell {
      display: table-cell;
      padding: 5px 10px;
    }
    .label,
    ki-icon {
      color: gray;
    }
    .vals {
      color: gray;
      text-align: center;
    }
    .descr {
      padding: 30px;
    }
    .title {
      font-weight: bold;
    }
    .content {
      display: table;
      padding: 30px;
    }
  `;

  api = getCurrentApi();

  static get properties() {
    return {
      groups: { type: Array },
      station: { type: Object },
    };
  }

  async onAfterEnter(location, options, router) {
    Object.assign(this, location.params);
    this.getGroups();
  }

  async getGroups() {
    this.station = this.station || (await this.api.getStation(this.stationId));
    const reports = await this.api._requestJson(
      `${this.station.station_no}/index.json`,
      `${this.api.dataPath}/reports/`,
    );
    this.groups = reports.data;
  }

  render() {
    const groups = this.groups || [];
    return this.station
      ? html`
          <div class="content">
            <div class="row">
              <div class="cell title">Nom de fichier</div>
              <div class="cell title">Télécharger</div>
            </div>
            ${groups.map(
              field => html` <div class="row">
                <div class="cell label">${field.name}</div>
                <div class="cell vals">
                  <a
                    href="${this.api.dataPath}/reports/${this.station
                      .station_no}/${field.name}"
                    target="_blank"
                    ><ki-icon icon="fa fa-download"></ki-icon
                  ></a>
                </div>
              </div>`,
            )}
          </div>
        `
      : html`<div>...</div>`;
  }
}
